import Component from './lose_reason_table.vue'
export default Component
